import { render, staticRenderFns } from "./SelectedLatestNewsDetail.vue?vue&type=template&id=ae8fcf82&"
import script from "./SelectedLatestNewsDetail.vue?vue&type=script&lang=js&"
export * from "./SelectedLatestNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports